import React from "react";
import styled from "styled-components";
import { Typography } from "@material-ui/core";

const FieldContainer = styled.div`
  label {
    display: block;
    margin: 20px 0px 5px 0px;
  }

  input[type="checkbox"] {
    height: 1em !important;
    transform: scale(1.5) !important;
    float: left;
    width: auto;
    height: auto;
    margin: 0px 5px 30px 0px !important;
    font-size: 24px;
  }

  input[type="checkbox"] + label {
    padding-left: 24px;
    font-size: 15px;
  }

  input {
    font-size: 100%;
  }

  input.error .error-message {
    background-color: #ef4c4c;
    border-radius: 3px;
    color: #ffe7e7;
    font-size: 14px;
    margin: 5px 0px 0px 0px;
    padding: 4px 10px;
  }
`;

const CheckboxField = ({ label, touched, error, ...props }) => (
  <FieldContainer>
    <input
      type="checkbox"
      {...props}
      className={touched && error ? `error` : ``}
      id={props.id || props.name}
    />
    {label && <label htmlFor={props.id || props.name}>{label}</label>}
    {touched && error && (
      <Typography className="error-message">{error}</Typography>
    )}
  </FieldContainer>
);

export default CheckboxField;
